/**
 * Location-type category colors — the ONE map for calendar tiles, booking
 * chips, hover cards, and every other surface that color-codes by location.
 * Uses the muted Okabe-Ito ramp (--cat-* tokens in index.css).
 */
import { categoryColor } from '@/shared/lib/category-color'

const HUES: Record<string, string> = { office: 'jade', home: 'orange', virtual: 'sky', block: 'purple' }

/** Resolve a location name to its hue. Defaults to jade (in-clinic) when unknown,
 * because the appointment list API doesn't carry the location TYPE — only the room name. */
function hueOf(location?: string): string {
  if (!location) return 'jade'
  const key = location.toLowerCase()
  if (HUES[key]) return HUES[key]
  // Heuristic: the name may contain a keyword (e.g. "Virtual Consultation", "Home Visit").
  if (key.includes('virtual') || key.includes('video') || key.includes('tele')) return 'sky'
  if (key.includes('home')) return 'orange'
  return 'jade'
}

/** Background tint for a calendar tile — the -100 step mixed 50/50 with white
 * so it reads as a subtle wash, not a coloured card. */
export function locationTileBg(location?: string): string {
  return `color-mix(in srgb, var(--cat-${hueOf(location)}-100) 50%, white)`
}

/** Edge-bar / indicator color (the -500 step). Falls back to profile hex. */
export function locationEdgeColor(location?: string, profileColor?: string | null): string {
  if (location) return `var(--cat-${hueOf(location)}-500)`
  return profileColor ? categoryColor(profileColor, 500, `var(--cat-jade-500)`) : 'var(--cat-jade-500)'
}
